var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var LocalNav = function(el) {
  this.$info = $('.product-info .content-width');
  this.$el = $(el);

  if( this.$info.length ) {

      $(window).add('main').on('scroll', function (event) {
          var infoTop = this.$info.offset().top - $('.header-bar').outerHeight();
          var scrollTop = $(event.target).scrollTop();

          $('body').toggleClass('local-nav-visible', infoTop < scrollTop);
      }.bind(this));
  }

  this.$el.on('change', 'select', function (event) {
      location.href = event.target.value;
  }.bind(this));
};

module.exports = LocalNav;